import React from 'react';

import { formatLocaleTime } from '../../utils/common';

import './members.css';

export const MemberCard = (props) => {
	const { member } = props;
	return (
		<div className='member-card'>
			<div>
				<img src={member.avatar} alt='avatar' />
			</div>
			<div className='details'>
				<h3>{member.handle}</h3>
				<div>{member.title}</div>
				<div>Member since <b>{formatLocaleTime(member.join_date, false)}</b></div>
			</div>
		</div>
	);
};